import React from 'react'
import Card from 'react-bootstrap/Card'
import {type InvoiceFormValues, InvoiceStatus} from '../types'
import InvoiceDataTable from './InvoiceDataTable'
import InvoiceForm from './InvoiceForm'
import { useAppSelector } from '../store/hooks'
import {
	useGetOptionsQuery,
	useGetRulesQuery,
	usePostInvoiceMutation,
} from '../store/api'
import { ErrorsFound, knownErrorHandling } from '../services/knownErrorHandling'
import { transformErrorToApiResponse } from '../store/api'
import useHasPermission from '../hooks/useHasPermission'

const InvoiceDetailsBlock: React.FC = () => {
	const { currentInvoice } = useAppSelector((state) => state.invoices)
	const hasInvoicesShowPermission = useHasPermission('invoices.show')
	const hasReviewPermission = useHasPermission('invoices.review')
	const hasUpdatePermission = useHasPermission('invoices.update')

	const { data: options, isLoading: isLoadingOptions } = useGetOptionsQuery()
	const { data: rules } = useGetRulesQuery()

	const [postInvoice, { isLoading: isLoadingPost, error: postInvoiceError }] =
		usePostInvoiceMutation()

	const handlePostInvoice = async (data: any, id: number) => {
		try {
			await postInvoice({ data, id }).unwrap()
		} catch (error) {
			console.error('Failed to post invoice:', error)
		}
	}

	const getFormErrors = (): ErrorsFound | null => {
		if (!postInvoiceError) return null
		const apiError = transformErrorToApiResponse(postInvoiceError)
		if (!apiError || apiError.status !== 422) return null
		return knownErrorHandling(apiError) || null
	}

	if (!hasInvoicesShowPermission) {
		return null
	}

	if (!currentInvoice || isLoadingOptions) {
		return (
			<Card className="h-100">
				<Card.Body>
					<Card.Title>Оберіть заявку</Card.Title>
				</Card.Body>
			</Card>
		)
	}

	const canEdit = currentInvoice.status === InvoiceStatus.reviewed
		? hasUpdatePermission
		: hasReviewPermission

	return (
		<Card className="h-100">
			<Card.Body>
				<Card.Title>Заявка {currentInvoice.number}</Card.Title>
				{currentInvoice.status === InvoiceStatus.reviewed && options && (
					<InvoiceDataTable options={options} data={currentInvoice} />
				)}
				{currentInvoice.status !== InvoiceStatus.reviewed && options && (
					canEdit && rules ? (
						<InvoiceForm
							rules={rules}
							options={options}
							errorsFromServer={getFormErrors()}
							isFetching={isLoadingPost}
							isSuccess={false}
							fetch={(req) => handlePostInvoice(req.data, req.id)}
							invoice={currentInvoice}
						/>
					) : (
						options && <InvoiceDataTable options={options} data={currentInvoice} />
					)
				)}
			</Card.Body>
		</Card>
	)
}

export default InvoiceDetailsBlock

